import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  fill: string;
}

const NewWindow = (props: Props): ReactElement => {
  const { width, height, fill } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 19"
    >
      <path
        fill={fill}
        d="M7.63 3.847c.152 0 .276.123.276.276 0 .074-.03.144-.081.196-.303.302-.713.472-1.14.472H3.81c-.47 0-.853.376-.865.843v6.556c0 .47.375.854.843.866h6.555c.471 0 .854-.376.866-.843V9.316c0-.428.17-.838.473-1.14.108-.108.283-.108.39 0 .053.052.082.122.082.195v3.819c0 1-.81 1.81-1.81 1.81H3.81c-1 0-1.81-.81-1.81-1.81V5.657c0-1 .81-1.81 1.81-1.81h3.82zM13.53 2c.247.01.447.202.469.445v.022l.001.021v3.926c-.01.254-.213.459-.467.47h-.039c-.255-.01-.46-.213-.47-.467v-2.75L6.931 9.734c-.19.191-.5.191-.69 0-.191-.19-.191-.5 0-.69l6.09-6.067H9.587c-.262-.01-.47-.225-.47-.489 0-.263.207-.477.467-.488h3.947z"
      />
    </svg>
  );
};

NewWindow.defaultProps = {
  width: '100%',
  height: '100%',
};

export default NewWindow;
